export default () => ({
  showNavigationBar: true,
  showEditor: true,
  showSidePreview: true,
  showStatusBar: true,
  showSideBar: false,
  showExplorer: false,
  scrollSync: true,
  focusMode: false,
  findCaseSensitive: false,
  findUseRegexp: false,
  sideBarPanel: 'menu',
  welcomeTourFinished: false,
});



// WEBPACK FOOTER //
// ./src/data/defaults/defaultLayoutSettings.js